







































































import { Component, Prop, Vue } from 'vue-property-decorator';
import Nullable from '@/types/nullable';
import Unavailability from '@/models/unavailability/unavailability';
import * as UnavailabilityApi from '@/api/unavailabilityApi';
import * as util from "comunet-jobs-and-technician-repository-shared/util";

@Component({})
export default class UnavailabilityForm extends Vue {
  @Prop({ type: Object }) public unavailability!: Unavailability;
  private startDateMenu: boolean = false;
  private showEndDate: boolean = false;
  private endDateMenu: boolean = false;
  private endDateValue: Nullable<Date> = null;
  private deleteLoading: boolean = false;
  private saveLoading: boolean = false;
  private errorMessage: Nullable<string> = null;

  formatDigits(value: number, digits: number){
    let text = `${value}`;

    while(text.length < digits){
      text = `0${text}`;
    }

    return text;
  }

  get startDate(){
    if (this.unavailability !== null) {
      let date = new Date(this.unavailability.onDate);
      return this.formatDateStringForDatePicker(date);
    }

    return null;
  }

  get startDateDisplay(){
    if (this.startDate !== null) {
      return this.formatDateStringForDisplay(this.startDate);
    }

    return null;
  }

  onStartDate(v: Date){
    this.unavailability.onDate = this.formatDateStringForDatePicker(new Date(v));
  }

  get endDate(){
    if(this.endDateValue == null){
      return null;
    }

    return this.formatDateStringForDatePicker(new Date(this.endDateValue));
  }

  get endDateDisplay(){
    if(this.endDate == null){
      return null;
    }

    return this.formatDateStringForDisplay(this.endDate);
  }

  onEndDate(v: Date){
    this.endDateValue = new Date(v);
  }

  formatDateStringForDatePicker(date: Date){
    return `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
  }

  formatDateStringForDisplay(dateString: string){     
    return util.readableDate(dateString);
  }

  allowedStartDates(val: string){    
    // Cannot select dates that are less than 7 days in the future
    let givenDate: number = new Date(val).getTime();
    let cutOffDate: number = new Date(this.formatDateStringForDatePicker(new Date())).getTime();
    if(givenDate - cutOffDate < 7 * 24 * 60 * 60 * 1000){
      return false;
    }

    if(this.endDateValue != null){
      // Cannot select after the end date
      if(givenDate > this.endDateValue.getTime()){
        return false;
      }
    }

    return true;
  }

  allowedEndDates(val: string){
    // Cannot select before the start date
    let givenDate: number = new Date(val).getTime();
    let startDate: number = new Date(this.startDate).getTime();
    if(givenDate < startDate){
      return false;
    }

    return true;
  }

  addEndDate(){
    this.showEndDate = true;
    this.endDateValue = new Date(this.startDate);
  }

  async onDelete(){
    this.deleteLoading = true;

    try {
      await UnavailabilityApi.deleteMyUnavailability(this.unavailability);

      this.$emit("onRemoveUnavailability", this.unavailability);
    } catch(err){
      this.errorMessage = err.message;
    }

    this.deleteLoading = false;
  }

  async onSave(){
    this.saveLoading = true;

    try {
      let newUnavailabilities = await UnavailabilityApi.updateMyUnavailability(this.unavailability, this.endDate || this.startDate);

      this.$emit("onAddOrUpdateUnavailability", newUnavailabilities);
    } catch(err){
      this.errorMessage = err.message;
    }

    this.saveLoading = false;
  }

  hideError(){
    this.errorMessage = null;
  }
}
